"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nacionalidades = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CommonSelect_1 = require("./CommonSelect");
const Nacionalidades = (props) => ((0, jsx_runtime_1.jsx)(CommonSelect_1.CommonSelect, Object.assign({ options: [
        { value: "Antiguano", label: "Antiguano" },
        { value: "Argentino", label: "Argentino" },
        { value: "Bahamense", label: "Bahamense" },
        { value: "Barbadiano", label: "Barbadiano" },
        { value: "Belizenho", label: "Belizenho" },
        { value: "Boliviano", label: "Boliviano" },
        { value: "Brasileiro", label: "Brasileiro" },
        { value: "Chileno", label: "Chileno" },
        { value: "Colombiano", label: "Colombiano" },
        { value: "Costarriquenho", label: "Costarriquenho" },
        { value: "Cubano", label: "Cubano" },
        { value: "Dominicano", label: "Dominicano" },
        { value: "Equatoriano", label: "Equatoriano" },
        { value: "Salvadorenho", label: "Salvadorenho" },
        { value: "Granadino", label: "Granadino" },
        { value: "Guatemalteco", label: "Guatemalteco" },
        { value: "Guianês", label: "Guianês" },
        { value: "Guianense", label: "Guianense" },
        { value: "Haitiano", label: "Haitiano" },
        { value: "Hondurenho", label: "Hondurenho" },
        { value: "Jamaicano", label: "Jamaicano" },
        { value: "Mexicano", label: "Mexicano" },
        { value: "Nicaraguense", label: "Nicaraguense" },
        { value: "Panamenho", label: "Panamenho" },
        { value: "Paraguaio", label: "Paraguaio" },
        { value: "Peruano", label: "Peruano" },
        { value: "Portorriquenho", label: "Portorriquenho" },
        { value: "Dominicana", label: "Dominicana" },
        { value: "São-cristovense", label: "São-cristovense" },
        { value: "São-vicentino", label: "São-vicentino" },
        { value: "Santa-lucense", label: "Santa-lucense" },
        { value: "Surinamês", label: "Surinamês" },
        { value: "Trindadense", label: "Trindadense" },
        { value: "Uruguaio", label: "Uruguaio" },
        { value: "Venezuelano", label: "Venezuelano" },
        { value: "Alemão", label: "Alemão" },
        { value: "Austríaco", label: "Austríaco" },
        { value: "Belga", label: "Belga" },
        { value: "Croata", label: "Croata" },
        { value: "Dinamarquês", label: "Dinamarquês" },
        { value: "Eslovaco", label: "Eslovaco" },
        { value: "Esloveno", label: "Esloveno" },
        { value: "Espanhol", label: "Espanhol" },
        { value: "Francês", label: "Francês" },
        { value: "Grego", label: "Grego" },
        { value: "Húngaro", label: "Húngaro" },
        { value: "Irlandês", label: "Irlandês" },
        { value: "Italiano", label: "Italiano" },
        { value: "Noruego", label: "Noruego" },
        { value: "Holandês", label: "Holandês" },
        { value: "Polonês", label: "Polonês" },
        { value: "Português", label: "Português" },
        { value: "Britânico", label: "Britânico" },
        { value: "Inglês", label: "Inglês" },
        { value: "Galês", label: "Galês" },
        { value: "Escocês", label: "Escocês" },
        { value: "Romeno", label: "Romeno" },
        { value: "Russo", label: "Russo" },
        { value: "Sérvio", label: "Sérvio" },
        { value: "Sueco", label: "Sueco" },
        { value: "Suíço", label: "Suíço" },
        { value: "Turco", label: "Turco" },
        { value: "Ucraniano", label: "Ucraniano" },
        { value: "Americano", label: "Americano" },
        { value: "Canadense", label: "Canadense" },
        { value: "Angolano", label: "Angolano" },
        { value: "Moçambicano", label: "Moçambicano" },
        { value: "Sul-africano", label: "Sul-africano" },
        { value: "Zimbabuense", label: "Zimbabuense" },
        { value: "Argélia", label: "Argélia" },
        { value: "Comorense", label: "Comorense" },
        { value: "Egípcio", label: "Egípcio" },
        { value: "Líbio", label: "Líbio" },
        { value: "Marroquino", label: "Marroquino" },
        { value: "Ganés", label: "Ganés" },
        { value: "Queniano", label: "Queniano" },
        { value: "Ruandês", label: "Ruandês" },
        { value: "Ugandense", label: "Ugandense" },
        { value: "Bechuano", label: "Bechuano" },
        { value: "Marfinense", label: "Marfinense" },
        { value: "Camaronense", label: "Camaronense" },
        { value: "Nigeriano", label: "Nigeriano" },
        { value: "Somali", label: "Somali" },
        { value: "Australiano", label: "Australiano" },
        { value: "Neozelandês", label: "Neozelandês" },
        { value: "Afegão", label: "Afegão" },
        { value: "Saudita", label: "Saudita" },
        { value: "Armeno", label: "Armeno" },
        { value: "Bangladesh", label: "Bangladesh" },
        { value: "Chinês", label: "Chinês" },
        { value: "Norte-coreano", label: "Norte-coreano" },
        { value: "Sul-coreano", label: "Sul-coreano" },
        { value: "Indiano", label: "Indiano" },
        { value: "Indonésio", label: "Indonésio" },
        { value: "Iraquiano", label: "Iraquiano" },
        { value: "Iraniano", label: "Iraniano" },
        { value: "Israelita", label: "Israelita" },
        { value: "Japonês", label: "Japonês" },
        { value: "Malaio", label: "Malaio" },
        { value: "Nepalês", label: "Nepalês" },
        { value: "Omanense", label: "Omanense" },
        { value: "Paquistanês", label: "Paquistanês" },
        { value: "Palestino", label: "Palestino" },
        { value: "Qatarense", label: "Qatarense" },
        { value: "Sírio", label: "Sírio" },
        { value: "Cingalês", label: "Cingalês" },
        { value: "Tailandês", label: "Tailandês" },
        { value: "Timorense", label: "Timorense" },
        { value: "Árabe", label: "Árabe" },
        { value: "Vietnamita", label: "Vietnamita" },
        { value: "Iemenita", label: "Iemenita" },
    ] }, props), void 0));
exports.Nacionalidades = Nacionalidades;
